import { DataBean } from "../DataBean";

export class Cities extends DataBean {



    public async deleteCities(idCities: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteCities_Number", [idCities]);
    }

    public async getCitiesCatalog(idCountries: any, idState: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getCitiesCatalog_Number_Number_String_Number_Number", [idCountries, idState, regexStr, page, recordsPerPage]);
    }

}